import React, { Component } from "react";
import { Col, Card, CardBody } from "reactstrap";
import "./MiniWidgets.css"; // Add custom styles

class MiniWidgets extends Component {
    render() {
        return (
            <>
                {this.props.reports.map((report, key) => (
                    <Col key={key} md={6} className="mb-4">
                        <Card className="mini-widget-card shadow-sm border-0">
                            <CardBody className="pb-3">
                                <div className="d-flex align-items-center justify-content-between">
                                    <div className="flex-1 overflow-hidden">
                                        <p className="widget-title mb-1 text-muted">
                                            {report.title}
                                        </p>
                                        <h3 className="widget-value mb-0 fw-bold">
                                            {report.value}
                                        </h3>
                                    </div>

                                    <div className="widget-icon-wrapper">
                                        <i className={`${report.icon} widget-icon`}></i>
                                    </div>
                                </div>
                            </CardBody>

                            <CardBody className="border-top bg-light-subtle py-2">
                                <div className="d-flex align-items-center">
                                    <span className="badge bg-success-subtle text-success font-size-11 me-2">
                                        <i className="mdi mdi-menu-up"></i>
                                        {report.rate}
                                    </span>
                                    <span className="text-muted widget-desc">
                                        {report.desc}
                                    </span>
                                </div>
                            </CardBody>
                        </Card>
                    </Col>
                ))}
            </>
        );
    }
}

export default MiniWidgets;
